import { render, staticRenderFns } from "./DepartSelect.vue?vue&type=template&id=3116ad9f&scoped=true&"
import script from "./DepartSelect.vue?vue&type=script&lang=js&"
export * from "./DepartSelect.vue?vue&type=script&lang=js&"
import style0 from "./DepartSelect.vue?vue&type=style&index=0&id=3116ad9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3116ad9f",
  null
  
)

export default component.exports